import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Escáner de la Inflamación Muda',
    items: ['Entendés por qué te sentís así aunque los estudios digan que estás bien', 'Identificás tus patrones digestivos personales sin ningún estudio médico', 'Descubrís la conexión real entre tu hinchazón, tu cansancio y tu cabeza pesada', 'Aprendés a leer las señales de tu cuerpo como un mapa, no como un misterio', 'Terminás la confusión de años en las primeras páginas'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — El Interruptor del Barrendero Digestivo',
    items: ['Entendés por qué amanecés inflamada aunque hayas cenado liviano', 'Activás el ciclo de limpieza intestinal que tu cuerpo tiene y no está usando', 'Ajustás tus horarios de comida de forma simple, sin dietas restrictivas', 'Descubrís qué hábito cotidiano está interrumpiendo tu digestión nocturna', 'En pocos días tu panza al despertar ya no es la misma'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — La Verdad sobre la Acidez y los Protectores Gástricos',
    items: ['Entendés por qué ciertos alimentos que deberían ser buenos te caen mal', 'Descubrís si tu estómago tiene demasiado o demasiado poco ácido gástrico', 'Eliminás la pesadez post-comida con ajustes simples sin sacrificar nada', 'Aprendés qué hacer si estás tomando protectores gástricos hace tiempo', 'Recuperás el placer de comer sin miedo a las consecuencias'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Kit de Maniobras de Alivio Mecánico',
    items: ['Tenés herramientas físicas para aliviar síntomas en minutos con tus propias manos', 'Aprendés la técnica I-L-U que mueve el contenido intestinal atrapado', 'Tenés un protocolo de rescate para cuando la crisis aparece y necesitás alivio ya', 'Activás el Nervio Vago con técnicas simples que calman la panza y el sistema nervioso', 'El alivio deja de depender de un medicamento y empieza a depender de vos'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — La Brújula de Reacciones Individuales',
    items: ['Construís tu propio mapa de alimentos que te ayudan y alimentos que te inflaman', 'Aprendés a detectar intolerancias sin estudios costosos ni laboratorios', 'Tenés un sistema de reintroducción gradual para ampliar tu menú sin riesgo', 'Medís tu progreso real con criterios concretos, no con sensaciones vagas', 'El sistema que funciona para vos, basado en tu cuerpo y no en el de otra persona'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan paso a paso listo para arrancar hoy', 'Herramientas con ingredientes de tu feria o súper del barrio', 'Resultados orientativos desde las primeras 48 horas', 'Checklist imprimible por etapa', 'Tracker de síntomas con criterios de medición', '100% adaptado a la mujer argentina de +55'];
  return <section className="py-24 bg-brand-dark" data-id="element-219">
      <div className="container mx-auto px-4" data-id="element-220">
        <div className="max-w-5xl mx-auto" data-id="element-221">
          <div className="text-center mb-16" data-id="element-222">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-223">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-224">
                SISTEMA MAPA DE ALIVIO INVISIBLE™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-225">
                Herramientas de implementación inmediata.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-226">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-227">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-228">
                <div className="text-5xl shrink-0" data-id="element-229">{tomo.emoji}</div>
                <div data-id="element-230">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-231">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-232">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-233">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-234" />
                        <span data-id="element-235">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-236">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-237">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-238">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-239">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-240" />
                  <span className="text-gray-200" data-id="element-241">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}